import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AgentGroupsDialogData {
  networkName: string;
  groupsLabel: string;
  groups: any[];
  currentGroupSlug: string;
}

// "All {label}" dialog (specs/ai-agent-home-redesign US-7). Closes with the picked group, or
// null for the whole network; closing any other way returns undefined (no change).
@Component({
  selector: 'app-agent-groups-dialog',
  templateUrl: './agent-groups-dialog.component.html',
  styleUrls: ['./agent-groups-dialog.component.scss'],
})
export class AgentGroupsDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<AgentGroupsDialogComponent, any | null>,
    @Inject(MAT_DIALOG_DATA) public data: AgentGroupsDialogData
  ) {}

  pick(group: any | null): void {
    this.dialogRef.close(group);
  }

  close(): void {
    this.dialogRef.close();
  }

  groupName(group: any): string {
    return group?.group_name || group?.name || '';
  }

  logo(group: any): string {
    return group?.group_logo || group?.group_base_logo || '';
  }

  isActive(group: any | null): boolean {
    return group ? group.group_slug === this.data.currentGroupSlug : !this.data.currentGroupSlug;
  }
}
